import { HTTPService, httpService } from "../../core/services/http.service";
import { GraphDataObject } from '../data/data-object/graph'
import { chartFromGraphDataObject } from '../data/transforms/transformers/charts'
import { Chart } from "../models/charts/chart";
import { TimeRange } from "../models/time-range.enum";
import { ChartType } from "../models/charts/chart-type.enum";

export class ChartService {
  constructor(private httpService: HTTPService) { }

  async load(chart:Chart):Promise<void> {
    const graphDO:GraphDataObject = await this.loadData(chart.type, chart.timeRange)
    chartFromGraphDataObject(chart , graphDO)
  }

  async refresh(chart:Chart) {
   return await this.load(chart) 
  }

  async loadData(chartType: ChartType, timeRange: TimeRange): Promise<GraphDataObject> {
    return await this.httpService.query(`graph/${chartType}/data?time_range=${timeRange}`, "GET") as GraphDataObject
  }

  async listCharts(): Promise<any> {
    return await this.httpService.query(`graph/list`, "GET")
  }
}

export const chartService = new ChartService(httpService)